import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

// Pages
import HomePage from "@/pages/HomePage";
import WikiPage from "@/pages/WikiPage";
import EditPage from "@/pages/EditPage";
import CreatePage from "@/pages/CreatePage";
import TalkPage from "@/pages/TalkPage";
import HistoryPage from "@/pages/HistoryPage";
import ClaimPage from "@/pages/ClaimPage";
import ClaimSuccess from "@/pages/ClaimSuccess";
import LoginPage from "@/pages/LoginPage";
import RegisterPage from "@/pages/RegisterPage";
import ProfilePage from "@/pages/ProfilePage";
import SearchResults from "@/pages/SearchResults";
import ReportPage from "@/pages/ReportPage";
import TermsPage from "@/pages/TermsPage";
import AdminDashboard from "@/pages/AdminDashboard";
import SuperAdminConfig from "@/pages/SuperAdminConfig";
import PricingPage from "@/pages/PricingPage";

// Context
import { AuthProvider } from "@/context/AuthContext";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/wiki/:slug" element={<WikiPage />} />
          <Route path="/wiki/:slug/edit" element={<EditPage />} />
          <Route path="/wiki/:slug/talk" element={<TalkPage />} />
          <Route path="/wiki/:slug/history" element={<HistoryPage />} />
          <Route path="/create" element={<CreatePage />} />
          <Route path="/claim/:pageId" element={<ClaimPage />} />
          <Route path="/claim/success" element={<ClaimSuccess />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/profile" element={<ProfilePage />} />
          <Route path="/search" element={<SearchResults />} />
          <Route path="/report" element={<ReportPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/admin/config" element={<SuperAdminConfig />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
